// dashboardReducer.js
import {
  FETCH_DASHBOARD_DATA_REQUEST,
  FETCH_DASHBOARD_DATA_SUCCESS,
  FETCH_DASHBOARD_DATA_FAILURE,
  RESET_DAILY_VISIT,
} from "../../actionTypes";

const initialState = {
  isLoading: false,
  data: null,
  error: null,
  is_daily_visit: 0,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_DASHBOARD_DATA_SUCCESS:
      console.log("dashboardReducer121", action.payload);
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        is_daily_visit: action.payload.data.is_daily_visit,
        error: null,
      };
    case FETCH_DASHBOARD_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case RESET_DAILY_VISIT:
      return {
        ...state,
        is_daily_visit: 0,
      };

    default:
      return state;
  }
};

export default dashboardReducer;
